import React from "react";
import FeaturePlaceholder from "../Common/FeaturePlaceholder";

const PlanShipment = () => {
  return (
    <FeaturePlaceholder
      icon="/logos/plan_shipment.svg"
      title="Plan shipment"
      subtitle="This page is being set up."
    />
  );
};

export default PlanShipment;
